import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Area,
  AreaChart,
} from 'recharts';

const data = [
  { name: 'Jan', completion: 400, budget: 2400 },
  { name: 'Feb', completion: 300, budget: 1398 },
  { name: 'Mar', completion: 200, budget: 9800 },
  { name: 'Apr', completion: 278, budget: 3908 },
  { name: 'May', completion: 189, budget: 4800 },
  { name: 'Jun', completion: 239, budget: 3800 },
  { name: 'Jul', completion: 349, budget: 4300 },
];

export default function MainChart() {
  const theme = useTheme();
  const color = theme.palette.primary.main;

  return (
    <Card variant="outlined" sx={{ width: '100%' }}>
      <CardContent>
        <Typography component="h2" variant="subtitle2" gutterBottom>
          Project Performance
        </Typography>
        <Stack sx={{ justifyContent: 'space-between' }}>
          <Typography variant="h4" component="p">
            84%
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Average completion rate across all active projects
          </Typography>
        </Stack>
        <Box sx={{ width: '100%', height: 300, mt: 2 }}>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="colorComp" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor={color} stopOpacity={0.3} />
                  <stop offset="95%" stopColor={color} stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid vertical={false} strokeDasharray="3 3" stroke={theme.palette.divider} />
              <XAxis
                dataKey="name"
                axisLine={false}
                tickLine={false}
                tick={{ fill: theme.palette.text.secondary, fontSize: 12 }}
                dy={10}
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                tick={{ fill: theme.palette.text.secondary, fontSize: 12 }}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: theme.palette.background.paper,
                  border: `1px solid ${theme.palette.divider}`,
                  borderRadius: 8,
                }}
              />
              <Area
                type="monotone"
                dataKey="completion"
                stroke={color}
                strokeWidth={2}
                fillOpacity={1}
                fill="url(#colorComp)"
              />
            </AreaChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </Card>
  );
}
